import { render } from "./LoginBox.vue?vue&type=template&id=0df253a3&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"

import "./LoginBox.vue?vue&type=style&index=0&id=0df253a3&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df253a3"]])

export default __exports__